import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import {
  CreateDepartmentApi,
  CreateDepartmentFailureApi,
  CreateDepartmentSuccessApi,
  DeleteDepartmentApi,
  DeleteDepartmentFailureApi,
  DeleteDepartmentSuccessApi,
  DepartmentApiActionTypes,
  LoadDepartmentApi,
  LoadDepartmentFailureApi,
  LoadDepartmentsApi,
  LoadDepartmentsFailureApi,
  LoadDepartmentsSuccessApi,
  LoadDepartmentSuccessApi,
  UpdateDepartmentApi,
  UpdateDepartmentFailureApi,
  UpdateDepartmentSuccessApi,
} from './department-api.actions';
import { DepartmentApiService } from './department-api.service';

@Injectable()
export class DepartmentApiEffects {
  loadDepartmentsApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DepartmentApiActionTypes.LoadDepartmentsApi),
      switchMap(({ payload }: LoadDepartmentsApi) =>
        this.srv.get(payload.params, payload.isCA).pipe(
          map((departments) => new LoadDepartmentsSuccessApi({ departments })),
          catchError((err) => of(new LoadDepartmentsFailureApi(err)))
        )
      )
    )
  );

  loadOneDepartmentsApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DepartmentApiActionTypes.LoadDepartmentApi),
      switchMap(({ payload: { id, isCA } }: LoadDepartmentApi) =>
        this.srv.getOne(id, isCA).pipe(
          map((department) => new LoadDepartmentSuccessApi({ department })),
          catchError(({ message }) => of(new LoadDepartmentFailureApi({ id, message })))
        )
      )
    )
  );

  createDepartmentApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DepartmentApiActionTypes.CreateDepartmentApi),
      mergeMap(({ payload }: CreateDepartmentApi) =>
        this.srv.create(payload.department, payload.isCA).pipe(
          map((department) => new CreateDepartmentSuccessApi({ department })),
          catchError((error) => of(new CreateDepartmentFailureApi(error)))
        )
      )
    )
  );

  updateDepartmentApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DepartmentApiActionTypes.UpdateDepartmentApi),
      mergeMap(({ payload }: UpdateDepartmentApi) =>
        this.srv.update(payload.department, payload.isCA).pipe(
          map((department) => new UpdateDepartmentSuccessApi({ department })),
          catchError((error) => of(new UpdateDepartmentFailureApi(error)))
        )
      )
    )
  );

  deleteDepartmentApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DepartmentApiActionTypes.DeleteDepartmentApi),
      mergeMap(({ payload }: DeleteDepartmentApi) =>
        this.srv.delete(payload.id, payload.isCA).pipe(
          map(({ id }) => new DeleteDepartmentSuccessApi({ id })),
          catchError((err) => of(new DeleteDepartmentFailureApi(err)))
        )
      )
    )
  );

  constructor(private actions$: Actions, private srv: DepartmentApiService) {}
}
